import React, { FC } from "react";
import { IMAGES } from "../../utils/images";
import { container, heading, headingContainer, gzpLogo } from "./styles";
// this comment tells babel to convert jsx to calls to a function called jsx instead of React.createElement
/** @jsx jsx */
import { jsx } from "@emotion/react";

interface HeaderProps {
  logo: string;
  list: { heading: string; link: string }[];
}

/**
 * Terms of use main header
 *
 */
const Header: FC<HeaderProps> = ({ logo, list }) => (
  <div css={container}>
    <img src={logo} alt="gamezop-logo" css={gzpLogo} />
    <div css={headingContainer}>
      {list.map((element) => (
        <a
          key={element.heading}
          target="_blank"
          href={element.link}
          css={heading}
        >
          {element.heading}
        </a>
      ))}
    </div>
  </div>
);

export default Header;
